import React, { useState, useEffect } from "react";
import { Row, Col, Input, Form } from "antd";
import { IonLabel } from "@ionic/react";

import { useTranslation } from "react-i18next";

const PostalCode = ({ state = {}, ...props }) => {
  const { data, form, rules, onChange } = state;
  const { t, i18n } = useTranslation();

  //for sync antd with state
  useEffect(() => {
    form?.setFieldsValue({ "address.postalCode": data });
  }, [data]);

  return (
    <Row {...props}>
      <Col span={6}>
        <IonLabel style={{ fontSize: "1rem" }}>{t("newVendor.postalCode")}&nbsp;</IonLabel>
      </Col>
      <Col span={18}>
        <Form form={form} layout="vertical" style={{ width: "100%" }}>
          <Form.Item name="address.postalCode" rules={rules}>
            <Input
              value={data}
              size="large"
              style={{ width: "100%" }}
              onChange={(e) => {
                const value = e?.target?.value?.replace(/\s+/g, ""); // Remove all spaces
                form?.setFieldsValue({ "address.postalCode": value });
                onChange({ address: { postalCode: value } });
              }}
            />
          </Form.Item>
        </Form>
      </Col>
    </Row>
  );
};

export default PostalCode;
